<!--
@create date 2024-1-2217
@desc 
https://resource.labelife.net/?mo=PM-2410-BT
https://resource.labelife.net/?mo=PM-2411-BT
https://resource.labelife.net/?mo=D520
-->
<template>
  <div class="resouce-div">
    <div class="page-title">Tutorial Videos for {{ productName }}</div>
    <div class="main-content">
      <van-collapse v-model="activeNames" accordion @change="changeActive">
        <div class="every-item" v-for="(item, index) in infoArr" :key="index">
          <!-- <div class="firstTitle">{{ index + 1 }}. {{ item.title }}</div> -->
          <van-collapse-item :name="index">
            <template #title>
              <div
                style="font-weight: 700; color: #252a33; font-size: 16px"
                @click="clickFirst(`${index + 1}.${item.title}`)"
              >
                {{ index + 1 }}. {{ item.title }}
              </div>
            </template>

            <van-collapse
              v-model="item.activeNames"
              :accordion="false"
              v-if="item.children && item.hasThird"
              :border="false"
            >
              <div v-for="(itemEx, index2) in item.children" :key="index2">
                <van-collapse-item
                  v-if="itemEx.children && itemEx.children.length > 0"
                  :name="index2"
                >
                  <template #title>
                    <div style="font-weight: normal">{{ itemEx.title }}</div>
                  </template>
                  <van-cell
                    :class="itemY.url ? 'linkVanCell' : ''"
                    :title="itemY.title"
                    :url="itemY.url"
                    v-for="(itemY, index3) in itemEx.children || []"
                    :key="index3"
                    @click="
                      () => {
                        if (itemY.url)
                          clickThirdVideo(item, itemEx, itemY, index);
                      }
                    "
                  />
                </van-collapse-item>
                <van-cell
                  v-else
                  :title="itemEx.title"
                  :url="itemEx.url"
                  :class="itemEx.url ? 'linkVanCell' : ''"
                  @click="
                    () => {
                      if (itemEx.url) clickSecondVideo(item, itemEx, index);
                    }
                  "
                />
              </div>
            </van-collapse>
            <div v-if="item.children && !item.hasThird">
              <van-cell
                v-for="itemEx in item.children"
                :class="itemEx.url ? 'linkVanCell' : ''"
                :title="itemEx.title"
                :url="itemEx.url"
                :key="itemEx.title"
                @click="
                  () => {
                    if (itemEx.url) clickSecondVideo(item, itemEx, index);
                  }
                "
              />
            </div>
          </van-collapse-item>
        </div>
      </van-collapse>
      <div class="bottom-button-div" v-show="productInfo.qrCodeUrl">
        <div
          class="custom-button"
          @click="
            () => {
              sensorsRecord({
                model: productName,
                key: 'clickMoreHelp',
                lang_name: 'English',
              });
              window.open(productInfo.qrCodeUrl);
            }
          "
        >
          Get More Help
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllParams, productInfos } from "./dataConfig.js";
import { sensorsRecord } from "@/util.js";

export default {
  name: "Resource",
  data() {
    return {
      window,
      activeNames: undefined,
      productName: "",
      infoArr: [],
      productInfo: {},
      sensorsRecord,
    };
  },
  mounted() {
    const params = getAllParams() || {};
    this.productName = params.mo;
    console.log(this.productName)
    this.getProductInfo();
    sensorsRecord(
      { model: this.productName, key: "view", lang_name: "English" },
      1
    );
    sensorsRecord(
      { model: this.productName, key: "WebStay", lang_name: "English" },
      3
    );
  },
  methods: {
    getProductInfo() {
      const { productName } = this;
      const proItem =
        productInfos.find((v) => v.productName === productName) || {};
      this.productInfo = proItem;
      this.infoArr = proItem.infoArr || [];
    },
    changeActive(activeName) {},
    clickFirst(title = "") {},
    clickSecondVideo(item, itemEx, index) {
      sensorsRecord(
        {
          model: this.productName,
          key: "operationGuide",
          lang_name: "English",
          feature_name: `${index + 1}.${item.title}`,
          feature_childname: itemEx.title,
        },
        2
      );
    },
    clickThirdVideo(item, itemEx, itemY, index) {
      sensorsRecord(
        {
          model: this.productName,
          key: "operationGuide",
          lang_name: "English",
          feature_name: `${index + 1}.${item.title}`,
          feature_childname: itemEx.title,
          third_childname: itemY.title,
        },
        2
      );
    },
  },
};
</script>

<style lang="less" src="./style.less" />



// WEBPACK FOOTER //
// src/view/guides/Resource.vue